module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/vi_tohoku-687b75902822ab404d50e6ef71c34ae9.jpg";